/**
 * A run's held-out score (TRA-1368): the reward of its best artifact. The
 * node names a grpo run's best artifact once a validation scored one of
 * its kept steps, and a P0 run's once its base test ran. Beside it, what
 * the run started at: the validation it ran before its first step, when
 * it ran one.
 */

import type { TrainingRunDocument } from '@/api/generated/model'

export interface HeldOutScore {
  artifact: string
  reward: number
  /** The validation reward before the first step; null when the run ran none. */
  start: number | null
}

export function heldOutScore(run: TrainingRunDocument): HeldOutScore | null {
  const best = run.artifacts.find((artifact) => artifact.name === run.best_artifact)
  if (best === undefined || best.eval_reward === null) return null
  const before = (run.validation ?? []).find((point) => point.step === 0)
  return {
    artifact: best.name,
    reward: best.eval_reward,
    start: before === undefined ? null : before.reward,
  }
}
